<template>
  <GekkoButton 
    v-show="showIntroLink"
    @click="showIntroAgain()"
    :text="$gettext('View intro')"
    :icon-right="true"
    variant="link"
    icon="fa-solid fa-circle-question"
  />
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import PremiumService from "@/store/services/premium.service.js";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'onboarding-intro-link',
  components: { GekkoButton },
  props: {
    onboardingIntro: {
      type: String,
      default: ''
    },
    openWelcome: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showIntroLink: false
    }
  },
  created () {
    PremiumService.list({ code: this.onboardingIntro }).then((response) => {
      const onboardingData = JSON.parse(response.data[0].content)
      this.showIntroLink = (onboardingData.slides && onboardingData.slides.length > 0)
      this.setOnboardingModalData(onboardingData)
      if (!this.openWelcome) {
        this.checkOnboarding('gekko_' + this.onboardingIntro)
      } else {
        this.setOnboardingCookieName('gekko_' + this.onboardingIntro);
        if (this.$route.query.welcome === 'yes') {
          this.openOnboarding()
        }
      }
    }).catch((err) =>  {
      console.log(err)
    })
  },
  methods: {
    ...mapActions({
      checkOnboarding: "onboarding/checkOnboarding",
    }),
    ...mapMutations({ 
      setOnboardingModalData: 'onboarding/SET_MODAL_CONTENT',
      setOnboardingCookie: 'onboarding/SET_ONBOARDING_COOKIE',
      openOnboarding: 'onboarding/OPEN_ONBOARDING',
      setOnboardingCookieName: 'onboarding/SET_ONBOARDING_COOKIENAME'
    }),
    showIntroAgain () {
      this.setOnboardingCookie(true)
      this.openOnboarding()
    }
  },
}
</script>

<style lang="scss">
</style>

